export default __webpack_public_path__ + "static/media/LightBlue0003.cd533f0d.png";